module.exports = __webpack_public_path__ + "img/img_ggl.c96229a2.png";